import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { Service } from '../interface';
import { ServicesService } from '../services.service';

@Component({
  selector: 'app-services-list',
  templateUrl: './services-list.component.html',
  styleUrls: ['./services-list.component.scss']
})
export class ServicesListComponent implements OnInit {
  loading = false;
  services$ = this.servicesService.services$
  @ViewChild('dataTable') private dataTable: Table
  constructor(
    private servicesService: ServicesService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadData('');
  }
  loadData(event: any) {
    this.loading = true;
    this.servicesService.getServices('').subscribe(res => {
      this.loading = false;
    }, err => {
      this.loading = false;
    })
  }

  editService(service_id: string) {
    this.router.navigate(['services', service_id]);
  }

  filterByPublished(event: any) {
    let value = event.target.value;
    if (value) {
      value = value === 'true' ? true : false;
      this.dataTable.filter(value, 'published', 'equals');
    }
    else {
      this.dataTable.filter(value, 'published', 'equals');
    }
  }

  public togglePublished(service: Service) {
    this.loading = true;
    this.servicesService.updateService(service.id, { published: !service.published }).subscribe(res => {
      this.loading = false;
    }, err => {
      this.loading = false;
    })
  }
}
